import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import MyAppBar from '../../components/MyAppBar';
import { Container, Paper, Typography, CircularProgress } from '@mui/material';
import AdministrativeModification from '../../components/AdministrativeModification';

const styles = {
  container: {
    padding: 1,
  },
  paper: {
    margin: 2,
    padding: 4,
  },
  indent: {
    paddingLeft: 5,
  },
};

export default function E(props) {
  const { yearmonth } = useParams();
  const [year, month] = yearmonth.split('-');
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);

  useEffect(() => {
    const getCases = async () => {
      setLoading(true);
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/AdministrativeModifications/${year}/${month}`
      );
      const casesResult = await response.json();
      setCases(casesResult);
      setLoading(false);
    };
    getCases();
  }, [month, year]);

  return (
    <React.Fragment>
      <MyAppBar title='Appendix E - Administrative Modifications' />
      <Container sx={styles.container}>
        <Paper sx={styles.paper}>
          <p>Modification to Board Action</p>
          {loading && <CircularProgress />}
          {!loading && cases.length === 0 ? (
            <Typography variant='h6'>None</Typography>
          ) : (
            cases.map((c, i) => (
              <AdministrativeModification permit={c} key={i} />
            ))
          )}
        </Paper>
      </Container>
    </React.Fragment>
  );
}
